import type { UnitConversion } from "@artisancode/api-types";

/** Factor to multiply an `activeUomId` qty by to get the base-unit qty, or null when no rule exists. */
export function toBaseFactor(
  conversions: UnitConversion[],
  activeUomId: string,
  baseUomId: string,
): number | null {
  const direct = conversions.find(
    (c) => c.fromUnitId === activeUomId && c.toUnitId === baseUomId,
  );
  if (direct) return Number(direct.factor);

  const inverted = conversions.find(
    (c) => c.fromUnitId === baseUomId && c.toUnitId === activeUomId,
  );
  if (inverted && Number(inverted.factor) > 0)
    return 1 / Number(inverted.factor);

  return null;
}
